require('./club-hole-by-hole.jade')
_ = require("lodash")

class ClubHoleByHoleCtrl
  constructor: ($scope, @ClubService) ->
    @courses = []
    $scope.isShowDetail = true
    $scope.isShowCourseOptions = false

    _.forEach $scope.$parent.clubInfo.courses, (course) =>
      @ClubService.getAnalysis(course.id).then( (data) =>
        @courses.push {course: course, analysis: data}
      ).catch () =>
        # when analysis data is not found
        @courses.push {course: course, analysis: {}}

    $scope.showDetail = ->
      $scope.isShowDetail = !$scope.isShowDetail

    $scope.selectCourse = (course) ->
      $scope.selectedCourse = course
      $scope.$emit 'courseChanged.gnp.club', course.id
      $scope.isShowCourseOptions = false

    $scope.showCourseOptions = ->
      $scope.isShowCourseOptions = !$scope.isShowCourseOptions

    $scope.selectCourse($scope.$parent.clubInfo.courses[0])

ClubHoleByHoleCtrl.$inject = [
  '$scope'
  'ClubService'
]

module.exports = ClubHoleByHoleCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-hole-by-hole/club-hole-by-hole-controller.coffee